import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    createTable as createTableApi,
    deleteTable as deleteTableApi,
    getShopTables as getShopTablesApi,
    updateTable as updateTableApi,
} from "../../helpers/backend_helper";

export interface CreateTablePayload {
    [key: string]: unknown;
}

export interface UpdateTablePayload {
    tableId: string | number;
    data: Record<string, unknown>;
}

export const getTables = createAsyncThunk(
    "Tables/getTables",
    async (params: Record<string, any> | undefined, { rejectWithValue }) => {
        try {
            const response = await getShopTablesApi(params ?? {});
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const createTable = createAsyncThunk(
    "Tables/createTable",
    async (data: CreateTablePayload, { rejectWithValue }) => {
        try {
            const response = await createTableApi(data);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const updateTable = createAsyncThunk(
    "Tables/updateTable",
    async ({ tableId, data }: UpdateTablePayload, { rejectWithValue }) => {
        try {
            const response = await updateTableApi(tableId, data);
            return {
                tableId,
                response,
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const deleteTable = createAsyncThunk(
    "Tables/deleteTable",
    async (tableId: string | number, { rejectWithValue }) => {
        try {
            const response = await deleteTableApi(tableId);
            return {
                tableId,
                response,
            };
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
